import { Input, Select, Typography } from 'antd';

const getName = (key) => {
  const json = {
    name: 'Name',
    addresses: 'Addresses',
    pan_number: 'PAN Number',
    iec: 'IEC',
    bank_accounts: 'Bank Accounts',
    stamp: 'Stamp',
    signature: 'Signature',
    currencies: 'Currencies',
    prefix: 'Prefix',
    brands: 'Brands',
    payment_terms: 'Payment Terms',
    sku_id: 'SKU Id',
    mensa_sku_id: 'Mensa SKU Id',
    mensa_style_id: 'Mensa Style Id',
    tax_code: 'Tax Code',
    mrp: 'MRP',
    master: 'Master',
    skuId: 'SKU Id',
    brand: 'Brand',
    buyer: 'Buyer',
    vendor: 'Vendor',
    skuTp: 'SKU Transfer Pricing',
    buyerTolerance: 'Buyer Tolerance',
    skuCogs: 'SKU COGS',
    cogs: 'COGS',
    currency: 'Currency',
    packing_type: 'Packing Type',
    length: 'Length',
    breadth: 'Breadth',
    height: 'Height',
    quantity: 'Quantity',
    gross_weight: 'Gross Weight',
    net_weight: 'Net Weight',
    sea_volumetric_weight: 'Sea Volumetric Weight',
    air_volumetric_weight: 'Air Volumetric Weight',
    transfer_pricing: 'Transfer Pricing',
    created_on: 'Creation Date',
    updated_on: 'Latest Updation',
    entity_type: 'Entity Type',
    entity_code: 'Entity Code',
    compensation_cess: 'Compensation Cess',
    start_price: 'Start Price',
    end_price: 'End Price',
    sgst: 'SGST',
    cgst: 'CGST',
    utgst: 'UGST',
    ugst: 'UGST',
    igst: 'IGST',
    vat: 'VAT',
    MENSA_ENTITY: 'Mensa Entity',
    BUYER: 'Buyer',
    SELLER: 'Seller',
    seller: 'Seller',
    po_identifier: 'PO Identifier',
    scan_identifier: 'Scan Identifier',
    sale_channel: 'Sales Channel',
    sale_model: 'Sales Model',
    type: 'Type',
    title: 'Title',
    body: 'Body',
    transport_name: 'Transporter Name',
    registered_transport_name: 'Registered Name',
    transport_doc_details: 'Details',
    brandId: 'Brand',
    buyerId: 'Buyer',
    sellerId: 'Seller',
    saleChannel: 'Sale Channel',
    saleModel: 'Sale Model',
    order_type: 'Order Type',
    shipping_mode: 'Shipping Mode',
    shipping_mode_label: 'Shipping Mode Label',
    shipping_factor: 'Shipping Factor',
    markup_value: 'Markup Value',
    markup_type: 'Markup Type',
    box_type: 'Box Type',
    case_size: 'Case Size',
    weight: 'Weight',
    cbm: 'CBM',
    cin_no: 'CIN No.',
    brand_id: 'Brand Id',
    entity_id: 'Entity Id'
  };
  const map = new Map(Object.entries(json));
  if (map.has(key)) {
    return map.get(key);
  }
  return key;
};

export const getWidth = (key) => {
  const json = {
    skuId: '150px',
    brand: '200px',
    vendor: '300px',
    entity_code: '250px',
    name: '300px',
    iec: '150px',
    pan_number: '150px',
    addresses: '130px',
    entity_type: '120px'
  };
  const map = new Map(Object.entries(json));
  if (map.has(key)) {
    return map.get(key);
  }
  return '200px';
};

const Filter = ({ options, allValues, setAllValues, onChange }) => {
  const handleChange = (value) => {
    const newV = { ...allValues };
    newV[options.name] = value;
    if (onChange) onChange(value);
    setAllValues(newV);
  };
  const handleInputChange = (event) => {
    const newV = { ...allValues };
    newV[options.name] = event.target.value;
    setAllValues(newV);
  };
  return (
    <div
      style={{
        minWidth: '350px',
        display: 'flex',
        justifyContent: 'space-around'
      }}>
      <Typography.Text className="required-after" level={5} strong style={{ alignSelf: 'center', padding: '0 16px' }}>
        {getName(options.name)} :
      </Typography.Text>
      {options.option && options.option.length > 1 ? (
        <Select
          filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          onChange={handleChange}
          options={options.option}
          placeholder="Select"
          showSearch
          style={{ minWidth: getWidth(options.name) }}
          value={allValues[options.name]}
        />
      ) : (
        <Input onChange={handleInputChange} style={{ width: getWidth(options.name) }} />
      )}
    </div>
  );
};

export default Filter;
